import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  .legal-root { font-family: 'DM Sans', sans-serif; color: #0f1117; background: #ffffff; overflow-x: hidden; }
  .legal-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 999; padding: 0 32px; height: 68px; display: flex; align-items: center; justify-content: space-between; background: rgba(255,255,255,0.92); backdrop-filter: blur(12px); border-bottom: 1px solid rgba(0,0,0,0.08); box-shadow: 0 2px 20px rgba(0,0,0,0.06); }
  .legal-nav-logo { font-family: 'Syne', sans-serif; font-size: 22px; font-weight: 800; color: #1a5c2a; text-decoration: none; display: flex; align-items: center; gap: 10px; letter-spacing: -0.3px; }
  .legal-logo-icon { width: 36px; height: 36px; background: #1a5c2a; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 18px; }
  .legal-nav-links { display: flex; align-items: center; gap: 8px; }
  .legal-btn-signin { font-size: 14px; font-weight: 600; color: #1a5c2a; text-decoration: none; padding: 9px 20px; border: 1.5px solid #1a5c2a; border-radius: 10px; transition: all 0.2s; }
  .legal-btn-signin:hover { background: #1a5c2a; color: white; }
  .legal-btn-start { font-size: 14px; font-weight: 600; color: white; text-decoration: none; padding: 9px 20px; background: #1a5c2a; border-radius: 10px; transition: all 0.2s; box-shadow: 0 2px 8px rgba(26,92,42,0.35); }
  .legal-btn-start:hover { background: #145022; }
  .legal-hero { background: linear-gradient(135deg, #0a1f0f 0%, #1a5c2a 50%, #0d3318 100%); padding: 120px 24px 64px; text-align: center; position: relative; overflow: hidden; }
  .legal-hero::after { content: ''; position: absolute; inset: 0; background-image: radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px); background-size: 32px 32px; pointer-events: none; }
  .legal-hero-tag { display: inline-flex; align-items: center; gap: 8px; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); color: rgba(255,255,255,0.9); font-size: 13px; font-weight: 500; padding: 6px 16px; border-radius: 50px; margin-bottom: 20px; position: relative; z-index: 1; }
  .legal-hero h1 { font-family: 'Syne', sans-serif; font-size: clamp(36px, 5vw, 60px); font-weight: 800; color: white; letter-spacing: -2px; margin-bottom: 16px; position: relative; z-index: 1; }
  .legal-hero-sub { font-size: 16px; color: rgba(255,255,255,0.65); position: relative; z-index: 1; }
  .legal-body { max-width: 820px; margin: 0 auto; padding: 64px 24px 80px; }
  .legal-toc { background: #f8faf8; border: 1px solid #e8f0e8; border-radius: 16px; padding: 28px 32px; margin-bottom: 48px; }
  .legal-toc-title { font-family: 'Syne', sans-serif; font-size: 16px; font-weight: 700; color: #0f1117; margin-bottom: 16px; }
  .legal-toc-list { list-style: none; display: grid; grid-template-columns: 1fr 1fr; gap: 8px 24px; }
  .legal-toc-list li a { font-size: 14px; color: #1a5c2a; text-decoration: none; font-weight: 500; transition: color 0.2s; }
  .legal-toc-list li a:hover { color: #145022; text-decoration: underline; }
  .legal-section { margin-bottom: 48px; scroll-margin-top: 88px; }
  .legal-section-title { font-family: 'Syne', sans-serif; font-size: 22px; font-weight: 800; color: #1a5c2a; margin-bottom: 16px; padding-bottom: 10px; border-bottom: 2px solid #e8f5e9; display: flex; align-items: center; gap: 10px; }
  .legal-section-title span { width: 32px; height: 32px; background: #1a5c2a; color: white; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 800; flex-shrink: 0; }
  .legal-subsection { margin-bottom: 20px; }
  .legal-subsection-title { font-family: 'Syne', sans-serif; font-size: 16px; font-weight: 700; color: #0f1117; margin-bottom: 8px; }
  .legal-p { font-size: 15px; line-height: 1.75; color: #333; margin-bottom: 12px; }
  .legal-list { list-style: none; margin: 8px 0 12px 0; }
  .legal-list li { font-size: 15px; line-height: 1.75; color: #333; padding: 6px 0 6px 24px; border-bottom: 1px solid #f0f0f0; position: relative; }
  .legal-list li:last-child { border-bottom: none; }
  .legal-list li::before { content: '✓'; position: absolute; left: 0; color: #1a5c2a; font-weight: 700; }
  .legal-highlight { background: #e8f5e9; border-left: 4px solid #1a5c2a; border-radius: 0 10px 10px 0; padding: 16px 20px; margin: 16px 0; }
  .legal-highlight p { font-size: 14px; color: #1a5c2a; font-weight: 500; line-height: 1.6; margin: 0; }
  .legal-warning { background: #fff8e1; border-left: 4px solid #f59e0b; border-radius: 0 10px 10px 0; padding: 16px 20px; margin: 16px 0; }
  .legal-warning p { font-size: 14px; color: #92400e; font-weight: 500; line-height: 1.6; margin: 0; }
  .legal-contact-card { background: linear-gradient(135deg, #0a1f0f, #1a5c2a); border-radius: 16px; padding: 32px; text-align: center; margin-top: 56px; }
  .legal-contact-card h3 { font-family: 'Syne', sans-serif; font-size: 22px; font-weight: 800; color: white; margin-bottom: 8px; }
  .legal-contact-card p { font-size: 15px; color: rgba(255,255,255,0.7); margin-bottom: 20px; }
  .legal-contact-btn { display: inline-block; background: white; color: #1a5c2a; font-weight: 700; font-size: 15px; text-decoration: none; padding: 12px 28px; border-radius: 10px; transition: all 0.2s; }
  .legal-contact-btn:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0,0,0,0.2); }
  .legal-footer { background: #0f1117; padding: 48px 32px 32px; }
  .legal-footer-inner { max-width: 1100px; margin: 0 auto; display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 32px; padding-bottom: 32px; border-bottom: 1px solid rgba(255,255,255,0.08); }
  .legal-footer-brand { font-family: 'Syne', sans-serif; font-size: 20px; font-weight: 800; color: white; display: flex; align-items: center; gap: 10px; margin-bottom: 10px; }
  .legal-footer-tagline { font-size: 13px; color: rgba(255,255,255,0.4); max-width: 220px; }
  .legal-footer-col-title { font-size: 13px; font-weight: 700; color: rgba(255,255,255,0.5); letter-spacing: 1px; text-transform: uppercase; margin-bottom: 16px; }
  .legal-footer-link { display: block; font-size: 14px; color: rgba(255,255,255,0.6); text-decoration: none; margin-bottom: 10px; transition: color 0.2s; }
  .legal-footer-link:hover { color: white; }
  .legal-footer-bottom { max-width: 1100px; margin: 24px auto 0; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; font-size: 13px; color: rgba(255,255,255,0.3); }
  @media (max-width: 768px) { .legal-nav { padding: 0 16px; } .legal-toc-list { grid-template-columns: 1fr; } .legal-footer-inner { flex-direction: column; } .legal-body { padding: 48px 16px 64px; } }
`;

export default function PrivacyPolicy() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const sections = [
    { id: 'overview',    num: '1',  title: 'Overview' },
    { id: 'collect',     num: '2',  title: 'Information We Collect' },
    { id: 'use',         num: '3',  title: 'How We Use Your Information' },
    { id: 'share',       num: '4',  title: 'How We Share Your Information' },
    { id: 'cookies',     num: '5',  title: 'Cookies & Tracking' },
    { id: 'retention',   num: '6',  title: 'Data Retention' },
    { id: 'security',    num: '7',  title: 'Security' },
    { id: 'rights',      num: '8',  title: 'Your Rights' },
    { id: 'children',    num: '9',  title: 'Children\'s Privacy' },
    { id: 'third',       num: '10', title: 'Third-Party Services' },
    { id: 'changes',     num: '11', title: 'Changes to This Policy' },
    { id: 'contact',     num: '12', title: 'Contact Us' },
  ];

  return (
    <div className="legal-root">
      <style>{styles}</style>

      {/* Navbar */}
      <nav className="legal-nav">
        <Link to="/" className="legal-nav-logo">
          <div className="legal-logo-icon">🍽️</div>
          QR Digi Menu
        </Link>
        <div className="legal-nav-links">
          <Link to="/login" className="legal-btn-signin">Sign In</Link>
          <Link to="/register" className="legal-btn-start" style={{ marginLeft: 8 }}>Get Started</Link>
        </div>
      </nav>

      {/* Hero */}
      <div className="legal-hero">
        <div className="legal-hero-tag">
          <span style={{ width: 8, height: 8, background: '#4ade80', borderRadius: '50%', display: 'inline-block' }} />
          Legal Document
        </div>
        <h1>Privacy Policy</h1>
        <p className="legal-hero-sub">Last updated: June 4, 2026 · QR Digi Menu Inc. — A Delaware Corporation</p>
      </div>

      {/* Body */}
      <div className="legal-body">

        <p className="legal-p" style={{ fontSize: 16, color: '#444', marginBottom: 40 }}>
          QR Digi Menu Inc. ("we", "us", or "our") is committed to protecting your privacy.
          This Privacy Policy explains how we collect, use, share, and protect information
          about restaurant owners, their staff, and diners who use our platform at
          getqrdigimenu.com. By using our platform, you agree to this Privacy Policy.
        </p>

        {/* TOC */}
        <div className="legal-toc">
          <div className="legal-toc-title">📌 Table of Contents</div>
          <ul className="legal-toc-list">
            {sections.map(s => (
              <li key={s.id}><a href={`#${s.id}`}>{s.num}. {s.title}</a></li>
            ))}
          </ul>
        </div>

        {/* Section 1 */}
        <div className="legal-section" id="overview">
          <div className="legal-section-title"><span>1</span>Overview</div>
          <p className="legal-p">
            QR Digi Menu is a SaaS platform that allows restaurant owners to create digital menus
            accessible via QR code, accept online orders, and manage their restaurant operations
            from a single dashboard. We take your privacy seriously and only collect data that is
            necessary to provide and improve our services.
          </p>
          <div className="legal-highlight">
            <p>✅ We do not sell your personal information to third parties. Ever.</p>
          </div>
        </div>

        {/* Section 2 */}
        <div className="legal-section" id="collect">
          <div className="legal-section-title"><span>2</span>Information We Collect</div>

          <div className="legal-subsection">
            <div className="legal-subsection-title">2.1 Information from Restaurant Owners (Account Holders)</div>
            <ul className="legal-list">
              <li><strong>Account information:</strong> Name, email address, password (encrypted)</li>
              <li><strong>Restaurant details:</strong> Restaurant name, address, city, phone number, cuisine type, opening hours, Google Maps link</li>
              <li><strong>Menu content:</strong> Menu items, categories, photos, prices, dietary tags, descriptions</li>
              <li><strong>Payment information:</strong> Billing details are collected and stored by Lemon Squeezy (our payment processor) — we do not store card numbers</li>
              <li><strong>Usage data:</strong> Login times, features used, dashboard activity</li>
            </ul>
          </div>

          <div className="legal-subsection">
            <div className="legal-subsection-title">2.2 Information from Diners (Menu Visitors)</div>
            <ul className="legal-list">
              <li><strong>Order information:</strong> Name, email address, phone number, order items when placing an order</li>
              <li><strong>Device information:</strong> Browser type, device type, IP address (for security and analytics)</li>
              <li><strong>Feedback:</strong> Optional reactions (❤️ Love, 👍 Like, 😊 Good) submitted via the platform</li>
            </ul>
          </div>

          <div className="legal-subsection">
            <div className="legal-subsection-title">2.3 Automatically Collected Information</div>
            <ul className="legal-list">
              <li>QR code scan counts and timestamps (no personal identifiers)</li>
              <li>Page views and session duration (aggregated, anonymized)</li>
              <li>Error logs and performance metrics</li>
            </ul>
          </div>
        </div>

        {/* Section 3 */}
        <div className="legal-section" id="use">
          <div className="legal-section-title"><span>3</span>How We Use Your Information</div>
          <p className="legal-p">We use the information we collect for the following purposes:</p>
          <ul className="legal-list">
            <li>To create and maintain your account and restaurant profile</li>
            <li>To display your digital menu to diners who scan your QR code</li>
            <li>To process and deliver online orders between diners and restaurants</li>
            <li>To send order confirmation emails to diners and order notifications to restaurants</li>
            <li>To process subscription payments through Lemon Squeezy</li>
            <li>To provide customer support and respond to inquiries</li>
            <li>To send important account and service notifications (e.g. subscription renewals)</li>
            <li>To improve and develop the platform based on usage patterns</li>
            <li>To detect and prevent fraud, abuse, and security threats</li>
            <li>To comply with legal obligations</li>
          </ul>
          <div className="legal-highlight">
            <p>💡 We do not use your data for advertising or sell it to marketing companies.</p>
          </div>
        </div>

        {/* Section 4 */}
        <div className="legal-section" id="share">
          <div className="legal-section-title"><span>4</span>How We Share Your Information</div>
          <p className="legal-p">We do not sell your personal information. We share data only in these limited circumstances:</p>

          <div className="legal-subsection">
            <div className="legal-subsection-title">4.1 Service Providers</div>
            <ul className="legal-list">
              <li><strong>Lemon Squeezy</strong> — Payment processing and subscription management</li>
              <li><strong>MongoDB Atlas</strong> — Secure cloud database hosting</li>
              <li><strong>SendGrid</strong> — Transactional email delivery</li>
              <li><strong>Vercel</strong> — Frontend hosting and deployment</li>
              <li><strong>Render</strong> — Backend API hosting</li>
            </ul>
            <p className="legal-p">These providers only access your data to perform services on our behalf and are contractually prohibited from using it for other purposes.</p>
          </div>

          <div className="legal-subsection">
            <div className="legal-subsection-title">4.2 Between Restaurants and Diners</div>
            <p className="legal-p">
              When a diner places an order, their name, email, phone number, and order details
              are shared with the restaurant owner so the order can be fulfilled. Diners consent
              to this sharing by completing the order form.
            </p>
          </div>

          <div className="legal-subsection">
            <div className="legal-subsection-title">4.3 Legal Requirements</div>
            <p className="legal-p">
              We may disclose your information if required by law, court order, or government
              authority, or to protect the rights, property, or safety of our company, users,
              or the public.
            </p>
          </div>

          <div className="legal-subsection">
            <div className="legal-subsection-title">4.4 Business Transfers</div>
            <p className="legal-p">
              In the event of a merger, acquisition, or sale of assets, your information may
              be transferred as part of that transaction. We will notify you before your
              information becomes subject to a different privacy policy.
            </p>
          </div>
        </div>

        {/* Section 5 */}
        <div className="legal-section" id="cookies">
          <div className="legal-section-title"><span>5</span>Cookies &amp; Tracking</div>
          <p className="legal-p">We use minimal cookies and local storage to operate the platform:</p>
          <ul className="legal-list">
            <li><strong>Session tokens:</strong> Stored in sessionStorage to keep you logged in during your browser session — cleared when you close the browser</li>
            <li><strong>Preferences:</strong> Language selection stored locally on your device</li>
            <li><strong>Analytics:</strong> Aggregated, anonymized scan counts — no personal tracking cookies</li>
          </ul>
          <div className="legal-highlight">
            <p>✅ We do not use third-party advertising cookies or tracking pixels.</p>
          </div>
        </div>

        {/* Section 6 */}
        <div className="legal-section" id="retention">
          <div className="legal-section-title"><span>6</span>Data Retention</div>
          <ul className="legal-list">
            <li><strong>Account data:</strong> Retained while your account is active. Deleted within 30 days of account closure upon request</li>
            <li><strong>Order data:</strong> Retained for 12 months for business and legal compliance, then deleted or anonymized</li>
            <li><strong>Menu content:</strong> Retained while your account is active and deleted upon account closure</li>
            <li><strong>Payment records:</strong> Retained by Lemon Squeezy per their data retention policies (typically 7 years for tax compliance)</li>
            <li><strong>Anonymous analytics:</strong> Retained indefinitely in aggregated, non-identifiable form</li>
          </ul>
        </div>

        {/* Section 7 */}
        <div className="legal-section" id="security">
          <div className="legal-section-title"><span>7</span>Security</div>
          <p className="legal-p">We implement industry-standard security measures to protect your data:</p>
          <ul className="legal-list">
            <li>All data transmitted over HTTPS with TLS encryption</li>
            <li>Passwords hashed using bcrypt — never stored in plain text</li>
            <li>MongoDB Atlas encrypted at rest and in transit</li>
            <li>Rate limiting on all API endpoints to prevent abuse</li>
            <li>Input sanitization to prevent injection attacks</li>
            <li>Security headers including HSTS, X-Content-Type-Options, and X-Frame-Options</li>
          </ul>
          <div className="legal-warning">
            <p>⚠ No system is 100% secure. If you suspect unauthorized access to your account, contact us immediately at hello@getqrdigimenu.com</p>
          </div>
        </div>

        {/* Section 8 */}
        <div className="legal-section" id="rights">
          <div className="legal-section-title"><span>8</span>Your Rights</div>
          <p className="legal-p">
            Depending on your location, you may have the following rights regarding your personal data:
          </p>

          <div className="legal-subsection">
            <div className="legal-subsection-title">8.1 All Users</div>
            <ul className="legal-list">
              <li><strong>Access:</strong> Request a copy of your personal data we hold</li>
              <li><strong>Correction:</strong> Update or correct inaccurate information</li>
              <li><strong>Deletion:</strong> Request deletion of your account and personal data</li>
              <li><strong>Portability:</strong> Request your data in a portable format</li>
              <li><strong>Opt-out:</strong> Unsubscribe from marketing emails at any time</li>
            </ul>
          </div>

          <div className="legal-subsection">
            <div className="legal-subsection-title">8.2 California Residents (CCPA)</div>
            <p className="legal-p">
              California residents have the right to know what personal information we collect,
              the right to delete personal information, the right to opt-out of the sale of
              personal information (we do not sell personal information), and the right to
              non-discrimination for exercising these rights.
            </p>
          </div>

          <div className="legal-subsection">
            <div className="legal-subsection-title">8.3 Virginia, Colorado, Connecticut, Texas, and Florida Residents</div>
            <p className="legal-p">
              Residents of these states have additional rights under their respective state
              privacy laws (VCDPA, CPA, CTDPA, TDPSA, FDBR) including the right to appeal
              our decisions regarding your privacy requests. To submit a request, email us at
              hello@getqrdigimenu.com with the subject line "Privacy Request."
            </p>
          </div>

          <div className="legal-highlight">
            <p>✅ To exercise any of your rights, email hello@getqrdigimenu.com — we respond within 30 days.</p>
          </div>
        </div>

        {/* Section 9 */}
        <div className="legal-section" id="children">
          <div className="legal-section-title"><span>9</span>Children's Privacy</div>
          <p className="legal-p">
            Our platform is not directed to children under the age of 13. We do not knowingly
            collect personal information from children under 13. If we become aware that a child
            under 13 has provided us with personal information, we will delete it immediately.
            If you believe we have collected information from a child under 13, please contact
            us at hello@getqrdigimenu.com.
          </p>
        </div>

        {/* Section 10 */}
        <div className="legal-section" id="third">
          <div className="legal-section-title"><span>10</span>Third-Party Services</div>
          <p className="legal-p">
            Our platform integrates with third-party services that have their own privacy policies.
            We encourage you to review their policies:
          </p>
          <ul className="legal-list">
            <li><strong>Lemon Squeezy</strong> — Payment processor: lemonsqueezy.com/privacy</li>
            <li><strong>MongoDB Atlas</strong> — Database hosting: mongodb.com/legal/privacy-policy</li>
            <li><strong>SendGrid (Twilio)</strong> — Email delivery: twilio.com/legal/privacy</li>
            <li><strong>Vercel</strong> — Frontend hosting: vercel.com/legal/privacy-policy</li>
            <li><strong>Render</strong> — Backend hosting: render.com/privacy</li>
            <li><strong>Google Translate API</strong> — Menu translation: policies.google.com/privacy</li>
          </ul>
          <p className="legal-p">
            We are not responsible for the privacy practices of these third parties.
            Links to external sites are provided for convenience only.
          </p>
        </div>

        {/* Section 11 */}
        <div className="legal-section" id="changes">
          <div className="legal-section-title"><span>11</span>Changes to This Policy</div>
          <p className="legal-p">
            We may update this Privacy Policy from time to time to reflect changes in our
            practices, technology, or legal requirements. When we make material changes, we will:
          </p>
          <ul className="legal-list">
            <li>Update the "Last updated" date at the top of this page</li>
            <li>Send an email notification to all registered account holders</li>
            <li>Display a notice in the admin dashboard for 30 days after the change</li>
          </ul>
          <p className="legal-p">
            Your continued use of the platform after the effective date of the updated policy
            constitutes your acceptance of the changes.
          </p>
        </div>

        {/* Section 12 */}
        <div className="legal-section" id="contact">
          <div className="legal-section-title"><span>12</span>Contact Us</div>
          <p className="legal-p">For any privacy-related questions, requests, or concerns:</p>
          <ul className="legal-list">
            <li><strong>Company:</strong> QR Digi Menu Inc. (A Delaware Corporation)</li>
            <li><strong>Address:</strong> 8 The Green #23752, Dover, DE 19901</li>
            <li><strong>Email:</strong> <a href="mailto:hello@getqrdigimenu.com" style={{ color: '#1a5c2a', fontWeight: 600 }}>hello@getqrdigimenu.com</a></li>
            <li><strong>Website:</strong> <a href="https://getqrdigimenu.com" style={{ color: '#1a5c2a', fontWeight: 600 }}>getqrdigimenu.com</a></li>
          </ul>
          <p className="legal-p">We respond to all privacy requests within 30 days.</p>
        </div>

        {/* CTA */}
        <div className="legal-contact-card">
          <h3>Questions about your privacy?</h3>
          <p>We take privacy seriously and respond to all requests within 30 days.</p>
          <a href="mailto:hello@getqrdigimenu.com" className="legal-contact-btn">📧 Contact Us</a>
        </div>
      </div>

      {/* Footer */}
      <footer className="legal-footer">
        <div className="legal-footer-inner">
          <div>
            <div className="legal-footer-brand">
              <div style={{ width: 32, height: 32, background: '#1a5c2a', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>🍽️</div>
              QR Digi Menu
            </div>
            <div className="legal-footer-tagline">The complete digital menu platform for modern restaurants.</div>
          </div>
          <div>
            <div className="legal-footer-col-title">Product</div>
            <Link to="/#features" className="legal-footer-link">Features</Link>
            <Link to="/#pricing" className="legal-footer-link">Pricing</Link>
            <Link to="/#how-it-works" className="legal-footer-link">How it works</Link>
          </div>
          <div>
            <div className="legal-footer-col-title">Account</div>
            <Link to="/register" className="legal-footer-link">Get Started</Link>
            <Link to="/login" className="legal-footer-link">Sign In</Link>
          </div>
          <div>
            <div className="legal-footer-col-title">Legal</div>
            <Link to="/privacy" className="legal-footer-link" style={{ color: 'rgba(255,255,255,0.9)' }}>Privacy Policy</Link>
            <Link to="/terms" className="legal-footer-link">Terms of Service</Link>
            <Link to="/refund" className="legal-footer-link">Refund Policy</Link>
          </div>
        </div>
        <div className="legal-footer-bottom">
          <span>© {new Date().getFullYear()} QR Digi Menu Inc. All rights reserved.</span>
          <span>Built for restaurants worldwide 🌍</span>
        </div>
      </footer>
    </div>
  );
}